import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';

import XhUserCell from '@/components/CreateCom/XhUserCell';
import RelatedBusiness from '@/components/RelatedBusiness';
import Repeat from './Repeat';
import { mapGetters } from 'vuex';
import { canlendarSaveAPI, canlendarUpdateAPI, canlendarQueryTypeListAPI } from '@/api/calendar';
export default {
  components: {
    XhUserCell: XhUserCell,
    RelatedBusiness: RelatedBusiness,
    Repeat: Repeat
  },
  props: {
    showCreate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '新增日程'
    },
    selectDiv: {
      type: String,
      default: ''
    },
    colorList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // cusCheck: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    todayDetailData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是否编辑所有的系列
    editAll: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      visible: false,
      // 是否展示按日期重复的dialog
      showRepeat: false,
      repeatForm: {},
      form: {
        title: '',
        schedule_id: '', // 日程类型
        owner_user_ids: 0,
        repetitionType: 1,
        start_time: '',
        end_time: ''
      },
      notice: [{
        value: 5,
        type: 1
      }],
      // 选中的关联项
      allData: {},
      businessRelation: {},
      // 选中的类型对应的颜色在颜色数组中的位置
      colorItem: '',
      choseMore: false,
      // 选中的参与人员
      checkedUser: [],
      repeatList: [{ label: '从不重复', value: 1
        // { label: '每天', value: 2 },
        // { label: '每周', value: 3 },
        // { label: '每月', value: 4 },
        // { label: '每年', value: 5 }
      }],
      timeList: ['', [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]],
      rules: {
        title: [{ required: true, message: '日程内容不能为空', trigger: 'blur' }],
        schedule_id: [{ required: true, message: '请选择日程类型', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        owner_user_ids: [{ required: true, message: '请选择参与人', trigger: 'change' }]
      },
      disabled: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      cusCheck: []
    };
  },

  computed: _extends({}, mapGetters(['userInfo'])),
  watch: {
    showCreate: function showCreate(val) {
      this.visible = val;
      if (val) {
        this.form = {
          title: '',
          schedule_id: '', // 日程类型
          owner_user_ids: '',
          repetitionType: 1,
          start_time: '',
          end_time: ''
        };
        this.notice = [{
          value: 5,
          type: 1
        }];
        this.checkedUser = [{ id: this.userInfo.id, realname: this.userInfo.realname }];
        this.form.owner_user_ids = [this.userInfo.id];
        if (this.selectDiv) {
          this.form.start_time = this.selectDiv + ' 08:00:00';
          this.changeStartTime(this.form.start_time);
        } else {
          this.form.start_time = '';
        }

        this.allData = {};
        this.getDetail();
        this.choseMore = false;
      }
    },


    allData: {
      handler: function handler(val) {
        var _this = this;

        _Object$keys(val).forEach(function (key) {
          var list = _this.allData[key] || [];
          var ids = [];
          list.forEach(function (item) {
            ids.push(item[key + '_id']);
          });
          _this.businessRelation[key + '_ids'] = ids;
        });
      },

      deep: true
    }
  },
  mounted: function mounted() {},

  methods: {
    /**
     * 关闭
     */
    beforeClose: function beforeClose(done) {
      if (this.showRepeat) {
        this.showRepeat = false;
        return;
      } else {
        this.$refs['ruleForm'].resetFields();
        this.$emit('close');
        done();
      }
    },


    /**
     * 详情
     */
    getDetail: function getDetail() {
      var _this2 = this;

      this.getCusCheck();
      var length = _Object$keys(this.todayDetailData).length;
      if (length !== 0) {
        this.form = {
          title: this.todayDetailData.title,
          schedule_id: this.todayDetailData.type_id || this.todayDetailData.schedule_id, // 日程类型
          owner_user_ids: this.todayDetailData.owner_user_info,
          repetitionType: this.todayDetailData.repetitionType || '',
          start_time: this.todayDetailData.start_time || '',
          end_time: this.todayDetailData.end_time || '',
          event_id: this.todayDetailData.event_id
          // batchId: this.todayDetailData.batchId
        };
        this.allData = {
          customer: (this.todayDetailData.customerList || []).map(function (item) {
            if (item.id) {
              item.customerId = item.id;
            }
            return item;
          }),
          contacts: (this.todayDetailData.contactsList || []).map(function (item) {
            if (item.id) {
              item.contactsId = item.id;
            }
            return item;
          }),
          contract: (this.todayDetailData.contractList || []).map(function (item) {
            if (item.id) {
              item.contractId = item.id;
            }
            return item;
          }),
          business: (this.todayDetailData.businessList || []).map(function (item) {
            if (item.id) {
              item.businessId = item.id;
            }
            return item;
          })
        };
        this.notice = this.todayDetailData.notice;
        this.form.repeatTime = this.todayDetailData.repeatTime;
        this.form.repeatRate = this.todayDetailData.repeatRate;
        this.form.endTypeConfig = this.todayDetailData.endTypeConfig;
        this.form.endType = this.todayDetailData.endType || '';
        this.checkedUser = this.todayDetailData.owner_user_info;
        this.cusCheck.forEach(function (item) {
          if (item.type_id === _this2.form.schedule_id) {
            _this2.colorItem = item.color;
            return;
          }
        });
      } else {
        var defaultList = [];
        this.cusCheck.forEach(function (item) {
          if (item.type === 2) {
            defaultList.push(item);
          }
        });
        this.colorItem = defaultList[0] && defaultList[0].color;
        this.form.schedule_id = defaultList[0] && defaultList[0].type_id;
        this.businessRelation = {};
      }
    },

    /**
     * 选择类型
     */
    changeType: function changeType(data) {
      this.colorItem = data.color;
    },


    /**
     * 选择员工
     */
    selectUser: function selectUser(data) {
      this.checkedUser = [];
      this.checkedUser = data.value;
      if (data.value.length) {
        this.form.owner_user_ids = data.value.map(function (item) {
          return item.id;
        });
        // .join(',')
      } else {
        this.form.owner_user_ids = '';
      }
    },


    /**
     * 选中的关联信息
     */
    checkInfos: function checkInfos(dataIds, data) {
      var _this3 = this;

      this.allData = data;
      _Object$keys(dataIds).forEach(function (key) {
        _this3.businessRelation[key] = dataIds[key].length ? dataIds[key] : '';
      });
      this.businessRelation = JSON.parse(_JSON$stringify(this.businessRelation));
    },


    /**
     * 解绑详情信息
     */
    unbindRelatedInfo: function unbindRelatedInfo(field, item, index) {
      var _this4 = this;

      this.$confirm('确认取消关联?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        var tempRelatedListData = JSON.parse(_JSON$stringify(_this4.allData));
        tempRelatedListData[field].splice(index, 1);
        _this4.allData = tempRelatedListData;
      }).catch(function () {
        _this4.$message.info('已取消操作');
      });
    },


    /**
     * 选择重复类型
     */
    selectRepeat: function selectRepeat(data) {
      this.showRepeat = true;
    },


    /**
     * 取消
     */
    cancle: function cancle() {
      if (this.showRepeat) {
        this.showRepeat = false;
        this.repeatForm = {};
        this.form.repetitionType = 1;
        this.$refs.repeat.$refs['ruleForm'].resetFields();
      } else {
        this.form = {};
        this.$refs['ruleForm'].resetFields();
        this.$emit('close');
      }
    },


    /**
     * 确定
     */
    sure: function sure() {
      var _this5 = this;

      if (this.showRepeat) {
        this.repeatForm = this.$refs.repeat.form;
        this.$refs.repeat.$refs['ruleForm'].validate(function (valid) {
          if (valid) {
            if (_this5.$refs.repeat.endDate) {
              _this5.repeatForm.endTypeConfig = _this5.$refs.repeat.endDate;
            } else {
              _this5.repeatForm.endTypeConfig = _this5.$refs.repeat.endCount;
            }
            _this5.form = _extends({}, _this5.form, _this5.repeatForm);
            _this5.showRepeat = false;
          } else {
            return false;
          }
        });
      } else {
        this.$refs['ruleForm'].validate(function (valid) {
          if (valid) {
            _this5.createSchedule();
          } else {
            return false;
          }
        });
      }
    },


    /**
     * 新建/编辑日程
     */
    createSchedule: function createSchedule() {
      var _this6 = this;

      var params = {};
      this.disabled = true;
      // if (Object.keys(this.businessRelation).length) {
      //   params.relation = this.businessRelation
      // }
      params = _extends({}, this.form, { owner_user_ids: typeof this.form.owner_user_ids[0] == 'number' ? this.form.owner_user_ids : this.form.owner_user_ids.map(function (item) {
          return item.id;
        }) });

      var _loop = function _loop(key) {
        params[key + '_ids'] = _this6.allData[key].map(function (item) {
          return item[key + '_id'] || item[key + '_id'];
        });
      };

      for (var key in this.allData) {
        _loop(key);
      }
      var length = _Object$keys(this.todayDetailData).length;
      var request = this.getRequest();
      params.notice = this.notice;
      if (length) {
        params.time = new Date(this.todayDetailData.start_time).getTime();
        if (this.editAll) {
          params.type = 3;
        } else {
          params.type = 2;
          params.event.repetitionType = 1;
        }
      }

      request(params).then(function (res) {
        _this6.$message.success('新建或编辑日程成功');
        _this6.disabled = false;
        _this6.$emit('createSuccess');
      }).catch(function () {
        _this6.disabled = false;
      });
    },


    /**
     * 获取请求
     */
    getRequest: function getRequest() {
      var length = _Object$keys(this.todayDetailData).length;
      if (length) {
        return canlendarUpdateAPI;
      } else {
        return canlendarSaveAPI;
      }
    },


    /**
     * 添加新提醒
     */
    addNewNotice: function addNewNotice() {
      this.notice.push({
        value: 5,
        type: 1
      });
    },


    /**
     * 删除提醒
     */
    deleteNotice: function deleteNotice(index) {
      this.notice.splice(index, 1);
    },


    /**
     * 更换时间类型
     */
    changeTimeType: function changeTimeType(type, index) {
      if (type == 1) {
        this.notice[index].value = 5;
      } else {
        this.notice[index].value = 1;
      }
    },


    /**
     * 改变开始时间
     */
    changeStartTime: function changeStartTime(date) {
      this.form.end_time = '';
      var template = new Date(date).getTime();
      this.pickerOptions = {
        disabledDate: function disabledDate(time) {
          return time.getTime() <= template - 24 * 60 * 60 * 1000;
        }
      };
    },
    getCusCheck: function getCusCheck() {
      var _this7 = this;

      canlendarQueryTypeListAPI().then(function (res) {
        _this7.cusCheck = res.data.list;
      }).catch();
    }
  }
};